"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  initialize: () => initialize
});
module.exports = __toCommonJS(src_exports);

// src/device-helpers.ts
var userAgentMatch = (matcher, userAgent) => {
  return userAgent.match(matcher) !== null;
};
var getDeviceData = ({
  userAgent,
  maxTouchPoints,
  devicePixelRatio,
  hasOnTouchStartEvent
}) => {
  const isIPad = userAgentMatch(/iPad/i, userAgent) || userAgentMatch(/Macintosh/i, userAgent) && maxTouchPoints > 1;
  const isIOS = isIPad || userAgentMatch(/^(?=.*(iPad|iPhone|iPod))(?!.*Windows)/i, userAgent);
  const isAndroid = userAgentMatch(/Android/i, userAgent);
  const isSafari = userAgentMatch(/safari/i, userAgent) && !userAgentMatch(/(Chrome|CriOS|chromium|android|phantom)/i, userAgent);
  const isMobile = userAgentMatch(
    /(iPhone|iPod|Android(?=.*Mobile).*|HTC|Fennec|IEMobile|BlackBerry|SymbianOS(?=.*AppleWebKit).*|Opera Mobi|Symbian|SonyEricsson|Nokia|SAMSUNG|LG)/i,
    userAgent
  );
  const isTablet = isIPad || isAndroid && !userAgentMatch(/Mobile/, userAgent);
  const isHermesApp = userAgentMatch(/Hermes/, userAgent);
  const isAftonbladetApp = userAgentMatch(/Aftonbladet Hermes/, userAgent);
  const isVgApp = userAgentMatch(/VG Hermes/, userAgent);
  const isSportApp = userAgentMatch(/VGSport Hermes/, userAgent);
  let hermesIOSAppVersion = { major: 0, minor: 0, patch: 0 };
  let hermesAndroidAppVersion = 0;
  let deeplinksSupported = false;
  if (isHermesApp) {
    if (isIOS) {
      const matches = userAgent.match(/Hermes\/(\d+)\.(\d+)\.(\d+)\s+/i);
      if (matches && matches.length === 4) {
        const [major, minor, patch] = matches.slice(1).map((v) => parseInt(v, 10));
        hermesIOSAppVersion = { major, minor, patch };
        deeplinksSupported = major >= 83;
      }
    } else if (isAndroid) {
      let matches = userAgent.match(/Hermes\/(\d+)\s+/i);
      if (matches && matches.length === 2) {
        hermesAndroidAppVersion = parseInt(matches[1], 10);
        deeplinksSupported = hermesAndroidAppVersion >= 999010454;
      } else {
        matches = userAgent.match(/Hermes\/(\d+)\.(\d+)\.(\d+)\s+/i);
        if (matches && matches.length === 4) {
          const [major, minor, patch] = matches.slice(1).map((v) => parseInt(v, 10));
          hermesAndroidAppVersion = { major, minor, patch };
          deeplinksSupported = true;
        }
      }
    }
  }
  const isHighDpiDevice = devicePixelRatio > 1;
  const isTouchDevice = hasOnTouchStartEvent;
  return {
    isIPad,
    isIOS,
    isSafari,
    isAndroid,
    isMobile,
    isTablet,
    isHermesApp,
    isAftonbladetApp,
    isVgApp,
    isSportApp,
    hermesIOSAppVersion,
    hermesAndroidAppVersion,
    deeplinksSupported,
    isHighDpiDevice,
    isTouchDevice
  };
};

// src/initialize.ts
var initialize = () => {
  const browserData = {
    userAgent: "",
    hasOnTouchStartEvent: false,
    maxTouchPoints: 0,
    devicePixelRatio: 1
  };
  if (typeof navigator !== "undefined" && typeof window !== "undefined") {
    browserData.userAgent = navigator.userAgent;
    browserData.maxTouchPoints = navigator.maxTouchPoints;
    browserData.devicePixelRatio = window.devicePixelRatio;
    browserData.hasOnTouchStartEvent = "ontouchstart" in window;
  }
  return getDeviceData(browserData);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  initialize
});
